export default __webpack_public_path__ + "2d005a2dba58cda95ed19fc0059ba498.svg";